export { MaterialTabsComponent } from './material-tabs/material-tabs.component';
export { MaterialTabComponent } from './material-tabs/material-tab/material-tab.component';
export { MaterialHeaderComponent } from './material-header/material-header.component';
export { MaterialBodyComponent } from './material-body/material-body.component';
export { MaterialFooterComponent } from './material-footer/material-footer.component';
